import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getCountryCodes} from 'src/openapi/admin/apis/GetCountryCodesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectCountries} from './services/dictionary-slice';

export const useCountries = () => {
    const apiDispatch = useAppDispatch();
    const countries = useSelector(selectCountries);

    const loadCountries = useCallback(() => {
        if (!countries.length) {
            apiDispatch(getCountryCodes());
        }
    }, [countries.length, apiDispatch]);

    const getCountryByCode = useCallback((code: string) => {
        return countries?.find(e => e.code === code);
    }, [countries]);

    return {countries, loadCountries, getCountryByCode};
};
